<template>
  <div class="hexagons_hos" :class="{ [curTheme]: true, [curMode]: true }">
    <div class="hos_stage">

      <div
        v-if="curMode === modes.orgTypes"
        @click="$router.push({ path: '/' })"
        class="hos_back"/>

      <div
        v-if="curMode !== modes.orgTypes"
        class="hos_mode-btns">
        <button
          class="hos_link"
          :class="{ on: curMode === modes.orgs }"
          @click="$router.push({ path: '/' })">
          По вузам</button>
        <button
          class="hos_link"
          :class="{ on: curMode === modes.types }"
          @click="$router.push({ path: '/by-types' })">
          По типам</button>
      </div>

      <button
        v-if="objsNumber > 0"
        class="hos_all hos_link"
        @click="$router.push({ path: '/objects/search' })">
        <span class="label">Всего объектов</span>
        <span class="number">{{ objsNumber }}</span>
      </button>

      <div class="hos_hexs" :style="hosOrgsStyle" key="hos_hexs">
        <template
          v-for="(o, i) in hexsArr">
          <div
            v-if="o.tpl === hexTpls.org"
            :key="`hex-${i}`"
            :style="hexStyles[i]"
            :data-num="o.Number"
            @click="o.Number > 0 ? $router.push({ path: o.path }) : null"
            class="hos_hex org_og">
            <div class="og_on"></div>
            <div class="og_data">
              <div class="og_num">{{ o.Number }}</div>
              <div class="og_label">{{ o.ShortName }}</div>
            </div>
          </div>
          <div
            v-else-if="o.tpl === hexTpls.type"
            :key="`hex-${i}`"
            :style="hexStyles[i]"
            :data-num="o.Number"
            class="hos_hex type_tp"
            @click="o.Number > 0 ? $router.push({ path: o.path }) : null">
            <div class="tp_data">
              <div class="tp_label">
                <div
                  class="tp_label-bg"
                  :style="{ 'background-image':
                    `url('../../static/grx/icons/objects/${o.Type}.svg')` }"/>
                  {{ o.Title }}
              </div>
              <div class="tp_num">{{ o.Number }}</div>
            </div>
          </div>
        </template>
      </div>

      <div class="hos_bars" key="hos_bars">
        <template
          v-for="(o, i) in hexsArr">
          <div
            v-if="o.tpl === hexTpls.org"
            :key="`bar-${i}`"
            @click="$router.push({ path: o.path })"
            :data-num="o.Number"
            class="bar_bar bar_org">
            <div class="bar_data">
              <div class="bar_label">{{ o.ShortName }}</div>
              <div class="bar_num">{{ o.Number }}</div>
            </div>
          </div>
          <div
            v-else-if="o.tpl === hexTpls.type"
            :key="`bar-${i}`"
            @click="$router.push({ path: o.path })"
            :data-num="o.Number"
            class="bar_bar bar_type">
            <div class="bar_data">
              <div
                class="bar_label"
                :style="{ 'background-image':
                  `url('../../static/grx/icons/objects/${o.Type}.svg')` }">
                {{ o.Title }}
              </div>
              <div class="bar_num">{{ o.Number }}</div>
            </div>
          </div>
        </template>
      </div>

      <div class="hos_pills-wrap" key="hos_pills-wrap">
        <div class="hos_pills-wrap-inside">
          <div
            v-for="(o, i) in  pillsArr"
            :key="`sm-${i}`"
            class="pill_pil"
            :data-num="o.Number"
            @click="o.Number > 0 ? $router.push({ path: o.path }) : null">
            <div class="pil_inner">
              <div class="pil_label">{{ o.ShortName }}</div>
              <div class="pil_num">{{ o.Number }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="hos_btn-wrap" v-if="pillsArr.length">
        <button class="lite-button" @click="togglePills">
          {{ pillsTriggerTexts[pillsState] }}
        </button>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable no-lonely-if, quotes, quote-props, comma-dangle */
import axios from 'axios';
import _ from 'lodash';
import { TweenMax, Power4 } from 'gsap/TweenMax';

const PILLS_OPENED = 'opened';
const PILLS_CLOSED = 'closed';

export default {

  data() {
    return {
      curMode: null,
      modes: {
        orgs: 'orgs',
        orgTypes: 'orgTypes',
        types: 'types',
      },
      hexTpls: {
        org: 'org',
        type: 'type',
      },
      responses: {
        catalog: null,
        organizations: null,
      },
      hexsArr: [],
      pillsArr: [],
      hexsToShow: 11,
      orgsHexsArr: [],
      objsNumber: 0,
      hexsInRow: {
        450: [2],
        550: [3, 2],
        750: [4, 3],
        1000: [5, 4],
        1400: [6, 5, 4],
        9999: [6],
      },
      hexProps: {
        width: 0,
        height: 0,
        marginTop: 0,
      },
      hexStyles: [],
      pillsState: null,
      pillsTriggerTexts: {
        closed: 'Все организации',
        opened: 'Меньше организаций',
      },
    };
  },

  created() {
    this.fetchData();
  },

  mounted() {
    window.addEventListener('resize', this.renderScene);
  },

  computed: {
    hosOrgsStyle() {
      return {
        'margin-top': `${-this.hexProps.marginTop + 35}px`,
      };
    },
  },

  watch: {
    $route() {
      this.setCurMode();
    },
  },

  methods: {

    setCurMode() {
      this.curMode = this.modes.orgs;
      if (this.$route.path === '/by-types') {
        this.curMode = this.modes.types;
      } else if (this.$route.params.orgId) {
        this.curMode = this.modes.orgTypes;
      }
      this.setRenderData();
    },

    fetchData() {
      // Fetch organizations pills state and render it
      this.pillsState = localStorage.getItem('hexagonsPillsState');
      if (!this.pillsState) {
        this.pillsState = PILLS_CLOSED;
      }
      // Prepare requests
      const isAuthenticated = this.$store.getters['user/isAuthenticated'];
      const requests = [(() => axios.get('objects/catalog'))()];
      if (isAuthenticated) {
        requests.push((() => axios.get('organizations'))());
      }
      // Perform requests
      axios.all(requests).then((r) => {
        this.responses.catalog = r[0].data;
        if (r.length > 1) {
          this.responses.organizations = r[1].data;
        }
        this.setCurMode();
      }).catch(() => {});
      this.objsNumber = 0;
      axios.get('statistics/platform').then((r) => {
        r.data.some((statVal) => {
          if (statVal.Name === 'objects') {
            this.objsNumber = statVal.Value;
            return true;
          }
          return false;
        });
      }).catch(() => {});
    },

    setRenderData() {
      if (this.curMode === this.modes.orgTypes) {
        this.setOrgTypesData();
      } else if (this.curMode === this.modes.types) {
        this.setTypesData();
      } else {
        this.setOrgsData();
      }
    },

    setOrgsData() {
      const isAuthenticated = this.$store.getters['user/isAuthenticated'];
      const orgs = this.responses.organizations;
      const catOrgs = this.responses.catalog.Organizations;
      // Get user organization id if authorized
      let userOrgId = '';
      if (isAuthenticated) {
        const userData = this.$store.getters['user/getUserData'];
        if (userData) {
          const userMail = userData.Mail;
          const userDomain = userMail.split('@')[1];
          for (let i = 0; i < orgs.length; i += 1) {
            const org = orgs[i];
            for (let j = 0; j < org.MailDomains.length; j += 1) {
              if (org.MailDomains[j] === userDomain) {
                userOrgId = org.OrganizationId;
                break;
              }
            }
            if (userOrgId.length > 0) {
              break;
            }
          }
        }
      }
      // Convert response object to array of orgs
      let orgsArr = [];
      let firstOrg = null;
      Object.keys(catOrgs).forEach((k) => {
        if (isAuthenticated && userOrgId === catOrgs[k].OrganizationId) {
          firstOrg = catOrgs[k];
        } else {
          orgsArr.push(catOrgs[k]);
        }
      });
      orgsArr = _.orderBy(orgsArr, ['Number'], ['desc']);
      if (firstOrg) {
        orgsArr.unshift(firstOrg);
      }
      this.hexsArr = [];
      this.pillsArr = [];
      // Set data arrays for rendering
      orgsArr.forEach((org, i) => {
        if (i < this.hexsToShow) {
          this.hexsArr.push(
            Object.assign({
              tpl: this.hexTpls.org,
              path: `/by-org/${orgsArr[i].OrganizationId}`,
            }, orgsArr[i])
          );
        } else {
          this.pillsArr.push(orgsArr[i]);
        }
      });
      this.$nextTick(this.renderScene);
    },

    setOrgTypesData() {
      const catOrgTypes = this.responses.catalog.TypesOrganizations;
      const catTypes = this.responses.catalog.Types;
      const catOrgs = this.responses.catalog.Organizations;
      this.hexsArr = [];
      this.pillsArr = [];
      const curOrgId = this.$route.params.orgId;
      this.hexsArr.push(
        Object.assign({
          tpl: this.hexTpls.org,
          path: `/objects/search?organization=${catOrgs[curOrgId].OrganizationId}`,
        }, catOrgs[curOrgId])
      );
      catOrgTypes.forEach((orgType, i) => {
        if (orgType.OrganizationId === curOrgId && catTypes[orgType.Type] && orgType.Number > 0) {
          this.hexsArr.push(
            Object.assign({
              tpl: this.hexTpls.type,
              Title: catTypes[orgType.Type].Title,
              path: `/objects/search?type=${orgType.Type}&organization=${orgType.OrganizationId}`,
            }, catOrgTypes[i])
          );
        }
      });
      this.$nextTick(this.renderScene);
    },

    setTypesData() {
      const catTypes = this.responses.catalog.Types;
      this.hexsArr = [];
      this.pillsArr = [];
      Object.keys(catTypes).forEach((typeId) => {
        this.hexsArr.push(
          Object.assign({
            tpl: this.hexTpls.type,
            path: `/objects/search?type=${catTypes[typeId].Type}`,
          }, catTypes[typeId])
        );
      });
      this.$nextTick(this.renderScene);
    },

    renderScene() {
      const stage = document.querySelector('.hos_stage');
      if (stage === null) return;
      if (this.pillsState === PILLS_OPENED) {
        this.$nextTick(() => { this.openPills(0); });
      }
      const hexsInRow = this.hexsInRow;
      const rowWidths = Object.keys(hexsInRow);
      let curRowWidths;
      const winWidth = window.innerWidth;
      for (let i = 0; i < rowWidths.length; i += 1) {
        if (winWidth < rowWidths[i]) {
          curRowWidths = rowWidths[i];
          break;
        }
      }
      const hexsNumVariants = hexsInRow[curRowWidths];
      let hexsInRowOne = hexsNumVariants[0];
      for (let i = 0; i < hexsNumVariants.length; i += 1) {
        const hexsInFirstRow = hexsNumVariants[i];
        let hexsInLastRow = this.hexsArr.length % ((hexsInFirstRow * 2) - 1);
        if (hexsInLastRow > hexsInFirstRow) {
          hexsInLastRow -= hexsInFirstRow;
        }
        if (hexsInLastRow === 0 || hexsInLastRow >= 2) {
          hexsInRowOne = hexsNumVariants[i];
          break;
        }
      }
      const hexsInRowTwo = hexsInRowOne - 1;
      const hexsInRowDuet = hexsInRowOne + hexsInRowTwo;
      const scrollbarWidth = 18;
      const stageWidth = stage.offsetWidth - scrollbarWidth;
      this.hexProps.width = Math.floor(stageWidth / hexsInRowOne);
      this.hexProps.height = Math.floor(this.hexProps.width * 1.1);
      this.hexProps.marginTop = -Math.floor(this.hexProps.width * 0.25);
      this.hexStyles = Array(this.hexsArr.length);
      // Calculate hexagons styles
      for (let i = 0; i < this.hexsArr.length; i += 1) {
        const hexIndexInRowDuet = i % hexsInRowDuet;
        // const hexsLeft = this.orgsArr.length - i;
        const isEvenRow = hexIndexInRowDuet - hexsInRowOne < 0;
        const rowDuetOffset = Math.floor(i / hexsInRowDuet);
        const hexsInCurRowTheory = hexIndexInRowDuet < hexsInRowOne
          ? hexsInRowOne : hexsInRowOne - 1;
        const isLastRowDuet = this.hexsArr.length < (rowDuetOffset + 1)
          * hexsInRowDuet;
        const rowIndexInRowDuet = hexsInRowDuet - hexIndexInRowDuet
          >= hexsInRowOne ? 0 : 1;
        // const hexIndexInRow = hexIndexInRowDuet < hexsInRowOne
        //   ? hexIndexInRowDuet : hexIndexInRowDuet - hexsInRowOne;
        let hexsInCurRowReal = hexsInCurRowTheory;
        let isLastRow = false;
        if (isLastRowDuet) {
          const hexsLeftInCurRowDuet = this.hexsArr.length
            - (rowDuetOffset * hexsInRowDuet);
          if (rowIndexInRowDuet === 0 && hexsLeftInCurRowDuet < hexsInRowOne) {
            hexsInCurRowReal = hexsLeftInCurRowDuet;
            isLastRow = true;
          } else if (rowIndexInRowDuet === 1) {
            hexsInCurRowReal = hexsLeftInCurRowDuet - hexsInRowOne;
            isLastRow = true;
          }
        }
        const rowIndex = (rowDuetOffset * 2)
          + Math.floor(hexIndexInRowDuet / hexsInRowOne);

        // Set render params
        const style = {
          width: `${this.hexProps.width}px`,
          height: `${this.hexProps.height}px`,
          'margin-top': `${this.hexProps.marginTop}px`,
        };
        if (isEvenRow) {
          // Even row
          if (hexIndexInRowDuet === 0) {
            style.clear = 'left';
            if (isLastRow) {
              const rowWidth = hexsInCurRowReal * this.hexProps.width;
              let marginLeft = (stageWidth - rowWidth) / 2;
              if (hexsInCurRowReal % 2 === hexsInRowTwo % 2 && rowIndex) {
                marginLeft -= this.hexProps.width / 2;
              }
              style['margin-left'] = `${marginLeft}px`;
            }
          }
        } else {
          // Odd row
          if (hexIndexInRowDuet === hexsInRowOne) {
            style.clear = 'left';
            if (isLastRow) {
              const rowWidth = hexsInCurRowReal * this.hexProps.width;
              let marginLeft = (stageWidth - rowWidth) / 2;
              if (hexsInCurRowReal % 2 === hexsInRowOne % 2) {
                marginLeft -= this.hexProps.width / 2;
              }
              style['margin-left'] = `${marginLeft}px`;
            } else {
              style['margin-left'] = `${this.hexProps.width / 2}px`;
            }
          }
        }
        this.hexStyles[i] = style;
      }
    },

    togglePills() {
      if (this.pillsState === PILLS_CLOSED) {
        this.openPills();
      } else {
        this.closePills();
      }
    },

    openPills(time = 0.8) {
      TweenMax.set('.hos_pills-wrap', { height: 'auto', opacity: 1 });
      TweenMax.from('.hos_pills-wrap', time, { height: 0, opacity: 0, ease: Power4.easeOut });
      this.setPillsState(PILLS_OPENED);
    },

    closePills() {
      TweenMax.to('.hos_pills-wrap', 0.8, { height: 0, opacity: 0, ease: Power4.easeOut });
      this.setPillsState(PILLS_CLOSED);
    },

    setPillsState(newState) {
      this.pillsState = newState;
      localStorage.setItem('hexagonsPillsState', newState);
    },
  },
};
</script>

<style lang="scss">
@import "../styles/common/main";

$mobile: 550px;

.hexagons_hos {
  max-width: 1790px;
  padding: 50px 0;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  @media (max-width: $mobile) {
    padding: 30px 0;
    &.orgTypes {
      padding-top: 80px;
    }
    &.orgs, &.types {
      padding-top: 100px;
    }
  }

  .hos_back {
    position: absolute;
    left: 50px;
    top: 25px;
    cursor: pointer;
    opacity: .7;
    @include transition(opacity);
    &:before {
      content: '';
      background: 50% 50% no-repeat url(../../static/grx/icons/btn-back.svg);
      background-size: contain;
      width: 50px;
      height: 50px;
      display: block;
    }
    &:hover {
      opacity: 1;
      @include transform(scale(1.1));
    }
    @media (max-width: $mobile) {
      left: 15px;
    }
  }

  .hos_mode-btns {
    position: absolute;
    margin: -2px -15px 0;
    left: 50px;
    top: 40px;
    .hos_link {
      margin: 0 15px;
    }
    @media (max-width: $mobile) {
      text-align: center;
      top: 35px;
      left: 0;
      right: 0;
      .hos_link {

      }
    }
  }

  .hos_all {
    position: absolute;
    right: 50px;
    top: 40px;
    .label {
      opacity: .6;
    }
    .number {
      opacity: 1;
      font-weight: bold;
      margin-left: 3px;
    }
    @media (max-width: $mobile) {
      top: 70px;
      left: 0;
      right: 0;
      width: 100%;
      text-align: center;
    }
  }
  &.orgTypes .hos_all {
    @media (max-width: $mobile) {
      right: 17px;
      left: auto;
      width: auto;
      top: 40px;
    }
  }

  .hos_link {
    font-size: 14px;
    color: #fff;
    opacity: .6;
    @include transition(opacity);
    text-transform: uppercase;
    cursor: pointer;
    &:hover,
    &.on {
      opacity: 1;
    }
  }
  &.theme-w .hos_link {
    color: #000;
  }

  .hos_hex {
    display: block;
    background: 50% 50% no-repeat url(/static/grx/hex/base.png);
    background-size: contain;
    cursor: pointer;
  }

  .hos_hexs {
    text-align: center;
    line-height: 0;
    @include clearfix;
    @media (max-width: $mobile) {
      display: none;
    }

    .org_og {
      position: relative;
      float: left;
      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: 50% 50% no-repeat url(/static/grx/hex/off.png);
        background-size: contain;
        z-index: 1;
      }
      &[data-num="0"] {
        cursor: default !important;
        .og_on {
          display: none !important;
        }
        /*
        @include transition(opacity);
        &:hover {
          opacity: .6;
        }
        */
      }
      .og_on {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        background: 50% 50% no-repeat url(/static/grx/hex/on.png);
        background-size: contain;
        z-index: 1;
        @include transition;
      }
      .og_data {
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        padding: 0 18%;
        display: inline-block;
        width: 100%;
        line-height: normal;
        text-align: center;
        @include transform(translateY(-65%))
      }
      .og_num {
        font-size: 30px;
        font-weight: bold;
        @media (max-width: 1100px) {
          font-size: 25px;
        }
        @media (max-width: 750px) {
          font-size: 20px;
        }
      }
      .og_label {
        font-size: 16px;
        line-height: 18px;
        padding: 7px 0;
        position: relative;
        &:before,
        &:after {
          content: '';
          position: absolute;
          width: 100%;
          height: 1px;
          left: 0;
          background: -moz-linear-gradient(left, rgba(76, 76, 76, 0) 0%,
            rgba(76, 76, 76, 1) 50%, rgba(76, 76, 76, 0) 100%);
          background: -webkit-linear-gradient(left, rgba(76, 76, 76, 0) 0%,
            rgba(76, 76, 76, 1) 50%, rgba(76, 76, 76, 0) 100%);
          background: linear-gradient(to right, rgba(76, 76, 76, 0) 0%,
            rgba(76, 76, 76, 1) 50%, rgba(76, 76, 76, 0) 100%);
          filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#004c4c4c',
            endColorstr='#004c4c4c', GradientType=1);
        }
        &:before {
          top: 0;
        }
        &:after {
          bottom: 0;
        }
        @media (max-width: 1470px) {
          font-size: 15px;
          line-height: 17px;
        }
        @media (max-width: 1270px) {
          font-size: 14px;
          line-height: 16px;
        }
        @media (max-width: 1000px) {
          font-size: 13px;
          line-height: 15px;
        }
        @media (max-width: 750px) {
          font-size: 12px;
          line-height: 14px;
        }
      }
      &:hover {
        .og_on {
          opacity: 1;
        }
      }
      &.og--on {
        @include transform(scale(1.05) !important);
        .og_on {
          opacity: 1;
        }
      }
    }

    .type_tp {
      position: relative;
      float: left;
      .tp_data {
        padding: 0 14%;
        display: inline-block;
        width: 100%;
        line-height: normal;
        text-align: center;
      }
      &[data-num='0'] {
        opacity: 0.6 !important;
        cursor: default !important;
      }
      .tp_label {
        font-size: 15px;
        line-height: 18px;
        position: absolute;
        left: 40px;
        right: 40px;
        top: 50%;
        @include transform(translateY(-60%));
        .tp_label-bg {
          content: '';
          height: 55px;
          display: block;
          width: 100%;
          background-size: contain;
          background: 50% 50% no-repeat;
          margin-bottom: 15px;
        }
        @media (max-width: 1450px) {
          font-size: 12px;
          line-height: 13px;
          .tp_label-bg {
            height: 45px;
            margin-bottom: 10px;
          }
        }
        @media (max-width: 950px) {
          font-size: 12px;
          line-height: 14px;
          left: 30px;
          right: 30px;
          .tp_label-bg {
            height: 35px;
            margin-bottom: 7px;
          }
        }
      }
      .tp_num {
        position: absolute;
        left: 0;
        right: 0;
        text-align: center;
        bottom: 14%;
        @media (max-width: 1070px) {
          display: none;
        }
      }
    }

  } // .hos_hexs

  .hos_bars {
    @include clearfix;
    margin-top: 20px;
    @media (min-width: 551px) {
      display: none;
    }
    .bar_bar {
      display: block;
      margin: 15px;
      padding: 15px 15px;
      background: rgba(255, 255, 255, .08);
      @include border-radius(10px);
      position: static;
      &.bar_type {
        .bar_label {
          padding: 0 15px 0 43px;
        }
      }
      &:first-of-type {
        margin-top: 0;
      }
      .bar_data {
        @include clearfix;
        display: table;
        width: 100%;
      }
      .bar_num {
        display: table-cell;
        vertical-align: middle;
        text-align: right;
        position: relative;
        font-size: 17px;
        color: rgba(255, 255, 255, .5);
      }
      .bar_label {
        display: table-cell;
        vertical-align: middle;
        font-size: 15px;
        line-height: 16px;
        height: 32px;
        overflow: hidden;
        padding: 0 15px 0 0;
        background-repeat: no-repeat;
      }
    }
  }

  .hos_btn-wrap {
    text-align: center;
    margin: 30px 0 5px;
  }

  .hos_pills-wrap {
    text-align: center;
    overflow: hidden;
    height: 0;
    .hos_pills-wrap-inside {
      padding: 25px 0 15px;
      @media (max-width: $mobile) {
        padding: 0;
        margin-top: -5px;
      }
    }
    @media (max-width: 650px) {
      margin-top: 10px;
    }
    @media (max-width: $mobile) {
      padding: 0 5px;
    }
  }

  .pill_pil {
    display: inline-block;
    vertical-align: top;
    font-size: 15px;
    line-height: 17px;
    margin: 7px 9px;
    padding: 6px;
    background: #1a1a1a;
    width: 18%;
    @include border-radius(35px);
    cursor: pointer;
    @media (max-width: 1180px) {
      width: 22%;
    }
    @media (max-width: 950px) {
      width: 29%;
    }
    @media (max-width: 650px) {
      margin: 6px;
      width: 46%;
    }
    @media (max-width: $mobile) {
      @include border-radius(10px);
    }
    &[data-num="0"] {
      cursor: default !important;
      .pil_inner:before {
        display: none !important;
      }
      /*
      @include transition(opacity);
      &:hover {
        opacity: .6;
      }
      */
    }
    .pil_inner {
      display: table;
      width: 100%;
      border: 1px solid rgba(255, 255, 255, .1);
      @include border-radius(30px);
      @include transition;
      padding: 10px 20px 7px;
      position: relative;
      @media (max-width: 650px) {
        border: none;
        padding: 7px;
        &:before,
        &:after {
          display: none;
        }
      }
      &:before {
        opacity: 0;
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        @include transition;
        background: #096cf9;
        background: -moz-linear-gradient(left, #096cf9 0%, #b55b90 100%);
        background: -webkit-linear-gradient(left, #096cf9 0%,#b55b90 100%);
        background: linear-gradient(to right, #096cf9 0%,#b55b90 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(
          startColorstr='#096cf9', endColorstr='#b55b90',GradientType=1 );
        @include border-radius(30px);
      }
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: #1a1a1a;
        @include border-radius(30px);
      }
    }
    .pil_label {
      display: table-cell;
      vertical-align: middle;
      text-align: left;
      padding-right: 10px;
      overflow: hidden;
      height: 35px;
      position: relative;
      z-index: 1;
      @media (max-width: 720px) {
        height: 28px;
        padding-right: 10px;
        font-size: 12px;
        line-height: 14px;
      }
    }
    .pil_num {
      display: table-cell;
      vertical-align: middle;
      text-align: right;
      font-size: 18px;
      position: relative;
      z-index: 1;
      color: rgba(255, 255, 255, .5);
      @media (max-width: 720px) {
        font-size: 16px;
      }
    }
    &:hover {
      .pil_inner {
        &:before {
          opacity: 1;
        }
      }
    }
  }

  &.theme-w {

    .hs_link {
      color: #333;
    }

    .hs_back {
      &:before {
        opacity: .125;
      }
    }

    .org_og {
      &:before {
        opacity: .04;
      }
      .og_label {
        &:before,
        &:after {
          opacity: .2;
        }
      }
    }

    .bar_bar {
      @include box-shadow(0 3px 20px rgba(0, 0, 0, .09));
      .bar_num {
        color: #333;
      }
    }

    .pill_pil {
      background: #fff;
      @include box-shadow(0 3px 20px rgba(0, 0, 0, .09));
      .pil_inner {
        border-color: rgba(0, 0, 0, .04);
        &:after {
          background: #fff;
        }
        .pil_num {
          color: rgba(0, 0, 0, .5);
        }
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Hexagons.vue